import { render } from "./waqf-card.vue?vue&type=template&id=5e6cb8cd&scoped=true"
import script from "./waqf-card.vue?vue&type=script&lang=js"
export * from "./waqf-card.vue?vue&type=script&lang=js"

import "./waqf-card.vue?vue&type=style&index=0&id=5e6cb8cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6cb8cd"]])

export default __exports__